import { render, staticRenderFns } from "./TriviaQuestion.vue?vue&type=template&id=1b662c0e&"
import script from "./TriviaQuestion.vue?vue&type=script&lang=js&"
export * from "./TriviaQuestion.vue?vue&type=script&lang=js&"
import style0 from "./TriviaQuestion.vue?vue&type=style&index=0&id=1b662c0e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports